module.exports = __webpack_public_path__ + "static/media/cosaic_3.691d0045.png";